// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/smart/app/src/models/activeList';
import model_2 from '/smart/app/src/models/report';
import model_5 from '/smart/app/src/models/useActivity';
import model_3 from '/smart/app/src/models/reportConfig';
import model_4 from '/smart/app/src/models/reportDetail';
import model_6 from '/smart/app/src/models/user';
import model_7 from '/smart/app/src/.umi-production/plugin-qiankun-slave/qiankunModel';

export const models = {
model_1: { namespace: 'activeList', model: model_1 },
model_2: { namespace: 'report', model: model_2 },
model_5: { namespace: 'useActivity', model: model_5 },
model_3: { namespace: 'reportConfig', model: model_3 },
model_4: { namespace: 'reportDetail', model: model_4 },
model_6: { namespace: 'user', model: model_6 },
model_7: { namespace: '@@qiankunStateFromMaster', model: model_7 },
} as const
